module.exports = __webpack_public_path__ + "img/Invasion-CRC_GSE206552.8b90a456.png";